// extracted by mini-css-extract-plugin
module.exports = {"arc":"Arc__arc__HWGRz","circle":"Arc__circle__WjHoQ"};